import queryString from 'query-string';
import { ArticleFilterI } from 'src/adminPanel/components/articleManagement/article/ArticleFilter';
import RequestArticle from 'src/adminPanel/entities/articleManagement/RequestArticle';
import RequestArticleAssignment from 'src/adminPanel/entities/articleManagement/RequestArticleAssignment';
import RequestArticleCustomField from 'src/adminPanel/entities/articleManagement/RequestArticleCustomField';
import RequestArticleGroup from 'src/adminPanel/entities/articleManagement/RequestArticleGroup';
import RequestArticleImage from 'src/adminPanel/entities/articleManagement/RequestArticleImage';
import RequestArticleProperty from 'src/adminPanel/entities/articleManagement/RequestArticleProperty';
import RequestCommissionModel from 'src/adminPanel/entities/articleManagement/RequestCommissionModel';
import VendorArticleProductGroup from 'src/adminPanel/entities/articleManagement/VendorArticleProductGroup';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

/* Article - Article */
export const getArticleArticle = (
    pageable: PageableQueryParams,
    articleFilter: ArticleFilterI,
    excludeSetProducts?: boolean
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable, ...articleFilter }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    if (excludeSetProducts) {
        query += `&excludeSetProducts=${excludeSetProducts}`;
    }
    const endpoint = `/api/article/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleArticle = (requestArticleArticle: RequestArticle): Promise<CallApiResult> => {
    return callApi('/api/article/add', { method: 'POST', data: requestArticleArticle });
};

export const updateExistingArticleArticle = (requestArticleArticle: RequestArticle): Promise<CallApiResult> => {
    return callApi('/api/article/update', { method: 'PUT', data: requestArticleArticle });
};

export const deleteArticleArticle = (requestArticleArticleId: string): Promise<CallApiResult> => {
    return callApi('/api/article/deactivate/' + requestArticleArticleId, { method: 'PUT' });
};

/* Article - ArticleAssignment */
export const getArticleArticleAssignment = (articleId: string): Promise<CallApiResult> => {
    let query = queryString.stringify({ articleId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/articleAssignment/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleArticleAssignment = (
    articleAssignmentRequestDto: RequestArticleAssignment
): Promise<CallApiResult> => {
    return callApi('/api/articleAssignment/add', { method: 'POST', data: articleAssignmentRequestDto });
};

export const updateArticleArticleAssignment = (
    articleAssignmentRequestDto: RequestArticleAssignment
): Promise<CallApiResult> => {
    return callApi('/api/articleAssignment/update', { method: 'PUT', data: articleAssignmentRequestDto });
};

export const deleteArticleArticleAssignment = (articleAssignmentId: string): Promise<CallApiResult> => {
    return callApi('/api/articleAssignment/delete/' + articleAssignmentId, { method: 'DELETE' });
};

/* Article - Article Group */
export const getArticleGroup = (pageable?: PageableQueryParams, articleTypeId?: string): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/articleGroup/list${query}`;
    return callApi(endpoint, { params: { articleTypeId: articleTypeId || '' } });
};

export const createNewArticleGroup = (requestArticleGroup: RequestArticleGroup): Promise<CallApiResult> => {
    return callApi('/api/articleGroup/add', { method: 'POST', data: requestArticleGroup });
};

export const updateArticleGroup = (requestArticleGroup: RequestArticleGroup): Promise<CallApiResult> => {
    return callApi('/api/articleGroup/update', { method: 'PUT', data: requestArticleGroup });
};

export const deleteArticleGroup = (
    requestArticleTypeId: string,
    requestArticleGroupId: string
): Promise<CallApiResult> => {
    return callApi('/api/articleGroup/delete/' + requestArticleTypeId + '/' + requestArticleGroupId, {
        method: 'DELETE',
    });
};

/* Article - Commission Model */
export const getArticleCommissionModel = (pageable: PageableQueryParams): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/commissionModels/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleCommissionModel = (
    requestCommissionModel: RequestCommissionModel
): Promise<CallApiResult> => {
    return callApi('/api/commissionModels/add', { method: 'POST', data: requestCommissionModel });
};

export const updateArticleCommissionModel = (
    requestCommissionModel: RequestCommissionModel
): Promise<CallApiResult> => {
    return callApi('/api/commissionModels/update', { method: 'PUT', data: requestCommissionModel });
};

export const deleteArticleCommissionModel = (requestCommissionModelId: string): Promise<CallApiResult> => {
    return callApi('/api/commissionModels/delete/' + requestCommissionModelId, { method: 'DELETE' });
};

/* Article - Article Type */
export const getArticleType = (): Promise<CallApiResult> => {
    // pageable: PageableQueryParams
    // let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    // if (query !== '') query = '?' + query;
    const endpoint = `/api/articleType/list`;
    return callApi(endpoint);
};

export const createNewArticleType = (requestArticleType: any): Promise<CallApiResult> => {
    return callApi('/api/articleType/add', { method: 'POST', data: requestArticleType });
};

export const updateArticleType = (requestArticleType: any): Promise<CallApiResult> => {
    return callApi('/api/articleType/update', { method: 'PUT', data: requestArticleType });
};

export const deleteArticleType = (requestArticleTypeId: string): Promise<CallApiResult> => {
    return callApi('/api/articleType/delete/' + requestArticleTypeId, {
        method: 'DELETE',
    });
};

/* Article - ArticleProperty */
export const getArticleProperty = (articleId: string): Promise<CallApiResult> => {
    // pageable: PageableQueryParams
    let query = queryString.stringify({ articleId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/articleProperty/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleProperty = (articlePropertyRequestDto: RequestArticleProperty): Promise<CallApiResult> => {
    return callApi('/api/articleProperty/add', { method: 'POST', data: articlePropertyRequestDto });
};

export const updateArticleProperty = (articlePropertyRequestDto: RequestArticleProperty): Promise<CallApiResult> => {
    return callApi('/api/articleProperty/update', { method: 'PUT', data: articlePropertyRequestDto });
};

export const deleteArticleProperty = (requestArticlePropertyId: string): Promise<CallApiResult> => {
    return callApi('/api/articleProperty/delete/' + requestArticlePropertyId, {
        method: 'DELETE',
    });
};

/* Article - ArticleCustomField */
export const getArticleCustomField = (articleId: string): Promise<CallApiResult> => {
    // pageable: PageableQueryParams
    let query = queryString.stringify({ articleId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/articleCustomField/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleCustomField = (
    articleCustomFieldRequestDto: RequestArticleCustomField
): Promise<CallApiResult> => {
    return callApi('/api/articleCustomField/add', { method: 'POST', data: articleCustomFieldRequestDto });
};

export const updateArticleCustomField = (
    articleCustomFieldRequestDto: RequestArticleCustomField
): Promise<CallApiResult> => {
    return callApi('/api/articleCustomField/update', { method: 'PUT', data: articleCustomFieldRequestDto });
};

export const deleteArticleCustomField = (articleCustomFieldId: string): Promise<CallApiResult> => {
    return callApi('/api/articleCustomField/delete/' + articleCustomFieldId, {
        method: 'DELETE',
    });
};

/* Article - ArticleImage */
export const getArticleImage = (articleId: string): Promise<CallApiResult> => {
    // pageable: PageableQueryParams
    let query = queryString.stringify({ articleId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/articleImage/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleImage = (
    articleImageInsertRequestDto: RequestArticleImage,
    uploadFile: any
): Promise<CallApiResult> => {
    const formData = new FormData();
    formData.append(
        'request',
        new Blob(
            [
                JSON.stringify({
                    articleId: articleImageInsertRequestDto.articleId,
                    sortOrder: articleImageInsertRequestDto.sortOrder,
                }),
            ],
            {
                type: 'application/json',
            }
        )
    );
    formData.append('file', uploadFile);

    return callApi(`/api/articleImage/add`, {
        method: 'POST',
        data: formData,
    });
};

export const updateArticleImage = (articleImageUpdateRequestDto: RequestArticleImage): Promise<CallApiResult> => {
    return callApi('/api/articleImage/update', {
        method: 'PUT',
        data: articleImageUpdateRequestDto,
    });
};

export const deleteArticleImage = (articleImageId: string): Promise<CallApiResult> => {
    return callApi('/api/articleImage/delete/' + articleImageId, {
        method: 'DELETE',
    });
};

/* Article - VendorArticleProductGroup */
export const getArticleProductGroups = (articleId: string, productGroupId?: string): Promise<CallApiResult> => {
    // pageable: PageableQueryParams
    let query = queryString.stringify({ articleId, productGroupId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/vendorArticleProductGroup/list${query}`;
    return callApi(endpoint);
};

export const createNewArticleProductGroup = (
    articleProductGroup: VendorArticleProductGroup
): Promise<CallApiResult> => {
    return callApi(`/api/vendorArticleProductGroup`, {
        method: 'POST',
        data: articleProductGroup,
    });
};

export const updateArticleProductGroup = (articleProductGroup: VendorArticleProductGroup): Promise<CallApiResult> => {
    return callApi('/api/vendorArticleProductGroup', {
        method: 'PUT',
        data: articleProductGroup,
    });
};

export const deleteArticleProductGroup = (articleProductGroupId: string): Promise<CallApiResult> => {
    return callApi('/api/vendorArticleProductGroup/' + articleProductGroupId, {
        method: 'DELETE',
    });
};

/* Vendor Article */
export const getVendorArticles = (articleId: string): Promise<CallApiResult> => {
    return callApi(`/api/vendorArticle/list?articleId=${articleId}`);
};

export const createVendorArticle = (vendorArticle: any): Promise<CallApiResult> => {
    return callApi('/api/vendorArticle', { method: 'POST', data: vendorArticle });
};

export const updateVendorArticle = (vendorArticle: any): Promise<CallApiResult> => {
    return callApi('/api/vendorArticle', { method: 'PUT', data: vendorArticle });
};

export const deleteVendorArticle = (vendorArticleId: string): Promise<CallApiResult> => {
    return callApi('/api/vendorArticle/' + vendorArticleId, { method: 'DELETE' });
};

/* Vendor Article Price */
export const getVendorArticlePrices = (
    articleId: string,
    vendorId: number | undefined,
    showPast: boolean
): Promise<CallApiResult> => {
    let query = queryString.stringify({ articleId, vendorId, showPast }, { skipNull: true, skipEmpty: true });
    if (query !== '') query = '?' + query;
    return callApi(`/api/vendorArticlePrice/list${query}`);
};

export const createVendorArticlePrice = (vendorArticlePrice: any): Promise<CallApiResult> => {
    return callApi('/api/vendorArticlePrice', { method: 'POST', data: vendorArticlePrice });
};

export const updateVendorArticlePrice = (vendorArticlePrice: any): Promise<CallApiResult> => {
    return callApi('/api/vendorArticlePrice', { method: 'PUT', data: vendorArticlePrice });
};

export const deleteVendorArticlePrice = (vendorArticlePriceId: string): Promise<CallApiResult> => {
    return callApi('/api/vendorArticlePrice/' + vendorArticlePriceId, { method: 'DELETE' });
};

/* Admin Product Groups */
export const getAdminProductGroups = (): Promise<CallApiResult> => {
    return callApi('/api/admin/productGroup/list');
};
